export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view



// WEBPACK FOOTER //
// ./src/store/modules/product_price_type/list/getters.js